import { render, staticRenderFns } from "./FeatureNotAvailable.vue?vue&type=template&id=9a117bca&"
import script from "./FeatureNotAvailable.vue?vue&type=script&lang=js&"
export * from "./FeatureNotAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports